module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.errorCode) ? _c('div', [(_vm.showTexts) ? _c('h2', [_vm._v(_vm._s(_vm.$t('general.creating-order')))]) : _vm._e(), _vm._v(" "), (_vm.showTexts) ? _c('p', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.showTexts) ? _c('p', [_vm._v(_vm._s(_vm.$t('general.creating-hang-on')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "inner",
    style: ('width:' + _vm.percentage + '%')
  })]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.percentage) + "%")])]) : _vm._e(), _vm._v(" "), (_vm.errorCode && _vm.showTexts) ? _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('general.we-got-error')))]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), (!_vm.errorMessage && !_vm.errorMessages.length) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('general.we-got-error-info', {
        phone: '<a href=\'tel:054-13 26 00\'>054&#8209;13&nbsp;26&nbsp;00</a>'
      }))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorMessage)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errorMessages.length) ? _c('ul', {
    staticClass: "error"
  }, _vm._l((_vm.errorMessages), function(message) {
    return _c('li', _vm._l((message), function(m) {
      return _c('span', {
        domProps: {
          "innerHTML": _vm._s(m)
        }
      })
    }), 0)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.codes.length) ? _c('ul', {
    staticClass: "error"
  }, _vm._l((_vm.codes), function(code) {
    return _c('li', [_vm._v(_vm._s(code[1]) + " (" + _vm._s(_vm.$t('general.error-code-code')) + " " + _vm._s(code[0]) + ")")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.order) ? _c('p', [_vm._v(_vm._s(_vm.$t('general.your-reference-number')) + ": "), _c('b', [_vm._v("#" + _vm._s(_vm.order.id))])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.$t('general.close')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1a2ead2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/CreatingOrder.vue
// module id = 1058
// module chunks = 0